import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import { useGeneralSetting } from "../context/GeneralSettingContext";
import CalculatorBtn from "./CalculatorBtn";
import Dsa from "./Dsa";
import { useDispatch, useSelector } from "react-redux";

const Header = () => {
  const navigate = useNavigate(); // kept for external/conditional navigation (e.g., after DSA form)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState("en");
  const [isDSAFormOpen, setIsDSAFormOpen] = useState(false);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [expandedMobileItems, setExpandedMobileItems] = useState([]);
  const [generalSettingData, setGeneralSettingData] = useState({});
  const { generalSetting, loading } = useGeneralSetting();

  const closeDSAForm = () => {
    setIsDSAFormOpen(false);
    document.body.style.overflow = "auto";
  };

  const openDSAForm = () => {
    setIsDSAFormOpen(true);
    document.body.style.overflow = "hidden";
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    if (!loading && generalSetting) {
      setGeneralSettingData(generalSetting);
    }
  }, [loading, generalSetting]);

  useEffect(() => {
    const interval = setInterval(() => {
      const select = document.querySelector(".goog-te-combo");
      if (select) {
        clearInterval(interval);
      }
    }, 500);
  }, []);

  const { menus } = useSelector((state) => state.menu);
  const [treeMenus, setTreeMenus] = useState([]);

  // Build menu tree
  const buildMenuTree = (menus) => {
    const menuMap = {};
    const roots = [];
    menus.forEach((menu) => {
      menuMap[menu.id] = { ...menu, children: [] };
    });
    menus.forEach((menu) => {
      if (menu.parent_id === null) {
        roots.push(menuMap[menu.id]);
      } else if (menuMap[menu.parent_id]) {
        menuMap[menu.parent_id].children.push(menuMap[menu.id]);
      }
    });
    return roots;
  };

  useEffect(() => {
    if (menus.length > 0) {
      const activeMenus = menus.filter((m) => m.status === "active");
      const tree = buildMenuTree(activeMenus);
      setTreeMenus(tree);
    }
  }, [menus]);

  // Recursive desktop submenu renderer (using Link)
  const renderSubmenuItems = (items) => {
    return items.map((item) => {
      const hasChildren = item.children?.length > 0;
      return (
        <li key={item.id} className={hasChildren ? "dropdown-submenu" : ""}>
          {hasChildren ? (
            <a
              href={item.url || "#"}
              onClick={(e) => e.preventDefault()}
              className="submenu-parent"
            >
              {item.name}
              <span className="submenu-arrow"></span>
            </a>
          ) : (
            <Link
              to={item.url || "#"}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {item.name}
            </Link>
          )}
          {hasChildren && (
            <ul className="submenu-content">
              {renderSubmenuItems(item.children)}
            </ul>
          )}
        </li>
      );
    });
  };

  // Recursive mobile menu renderer (using Link)
  const renderMobileMenu = (items, level = 0) => {
    if (!items?.length) return null;
    return items.map((item) => {
      const hasChildren = item.children?.length > 0;
      const isExpanded = expandedMobileItems.includes(item.id);
      return (
        <div key={item.id} className={`mobile-menu-item level-${level}`}>
          <div className="mobile-menu-item-header">
            {hasChildren ? (
              <a
                href={item.url || "#"}
                onClick={(e) => {
                  e.preventDefault();
                  toggleMobileExpand(item.id);
                }}
              >
                {item.name}
              </a>
            ) : (
              <Link
                to={item.url || "#"}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            )}
            {hasChildren && (
              <button
                type="button"
                className="mobile-expand-btn"
                onClick={() => toggleMobileExpand(item.id)}
              >
                {isExpanded ? "−" : "+"}
              </button>
            )}
          </div>
          {hasChildren && isExpanded && (
            <div className="mobile-submenu">
              {renderMobileMenu(item.children, level + 1)}
            </div>
          )}
        </div>
      );
    });
  };

  const toggleMobileExpand = (itemId) => {
    setExpandedMobileItems((prev) =>
      prev.includes(itemId)
        ? prev.filter((id) => id !== itemId)
        : [...prev, itemId],
    );
  };

  return (
    <>
      <header>
        <nav className="navbar header-main scrolled-off" id="header-scrolled">
          <Link to="/">
            <img
              src={generalSettingData?.logo || "/images/kfs-logo.png"}
              alt="Logo"
              className="header-logo"
            />
          </Link>

          {/* Desktop menu with Link */}
          <ul className="nav-links">
            {treeMenus.map((menu) => {
              const hasChildren = menu.children?.length > 0;
              return (
                <li key={menu.id} className={hasChildren ? "dropdown" : ""}>
                  {hasChildren ? (
                    <a
                      href={menu.url || "#"}
                      onClick={(e) => e.preventDefault()}
                    >
                      {menu.name}
                      <span className="dropdown-arrow">▼</span>
                    </a>
                  ) : (
                    <Link to={menu.url || "#"}>{menu.name}</Link>
                  )}
                  {hasChildren && (
                    <ul className="dropdown-content">
                      {renderSubmenuItems(menu.children)}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>

          <div className="nav-buttons">
            <button className="partner-btn" onClick={() => navigate("/coming")}>
              Login
            </button>
            <button
              className="apply-btn"
              onClick={openDSAForm}
              style={{ marginRight: "20px" }}
            >
              Become DSA
            </button>
          </div>
        </nav>
      </header>

      <Breadcrumb />
      <CalculatorBtn />

      {/* Mobile Header */}
      <div className="mobile-menu-toggle-container">
        <Link to="/">
          <img
            src={generalSettingData?.logo || "/images/kfs-logo.png"}
            alt="Logo"
            className="header-logo"
          />
        </Link>
        <div className="language-toggle-button">
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar ${isMobileMenuOpen ? "open" : ""}`}>
        <div className="mobile-sidebar-header">
          <img
            src={generalSettingData?.logo || "/images/kfs-logo.png"}
            alt="Logo"
            className="header-logo"
          />
          <button
            className="mobile-close-btn"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            ×
          </button>
        </div>

        <div className="mobile-nav-links">{renderMobileMenu(treeMenus)}</div>

        <div className="mobile-nav-buttons">
          <button
            className="mobile-partner-btn"
            onClick={() => {
              setIsMobileMenuOpen(false);
              navigate("/coming");
            }}
          >
            Login
          </button>
          <button className="mobile-apply-btn" onClick={openDSAForm}>
            Become DSA
          </button>
        </div>
      </div>

      {/* Overlay */}
      {isMobileMenuOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      <Dsa isOpen={isDSAFormOpen} onClose={closeDSAForm} />
    </>
  );
};

export default Header;
